import React, { Component } from 'react';
import styled from 'styled-components';
import { secondaryFont } from 'react-components/dist/values/fonts/fonts';
import { dark, primary, white } from 'react-components/dist/values/colors/colors';

const Wrapper = styled.div`
  width: 100%;
  margin-top: 6px;
  position: relative;
`;

const StyledSelect = styled.select`
  background: none;
  width: 100%;
  -webkit-appearance: none;
  -moz-appearance: none;
  text-indent: 1px;
  text-overflow: '';
  border: none;
  border-bottom: 3px solid;
  border-color: ${props => (props.light ? dark : white)};
  color: ${props => (props.light ? dark : white)};
  outline: 0;
  border-radius: 0;
  font-family: ${secondaryFont.large};
  font-size: 1em;
  padding: 5px 6px;
  box-sizing: border-box;
  &:hover {
    cursor: pointer;
  }
  &:focus {
    border-color: ${props => (props.dark ? primary : dark)};
  }
  &:invalid {
    color: ${props => (props.light ? dark : white)}70;
  }
`;

const Icon = styled.div`
  position: absolute;
  right: 6px;
  top: 50%;
  transform: translateY(-50%);
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-top: 6px solid ${props => (props.light ? dark : white)};
`;

class Select extends Component {
  handleChange = e => {
    this.props.onChange(e.target.value);
  };

  render() {
    return (
      <Wrapper>
        <Icon light={this.props.light} />
        <StyledSelect
          defaultValue=""
          light={this.props.light}
          dark={this.props.dark}
          onChange={e => this.handleChange(e)}
          name={this.props.name}
          required
        >
          <option
value=""
disabled>
            {this.props.placeholder}
          </option>
          {this.props.options.map((x, i) => {
            return (
              <option
key={i}
value={x}>
                {x}
              </option>
            );
          })}
        </StyledSelect>
      </Wrapper>
    );
  }
}

export default Select;
